<template>
  <div class="backimg">
    <div class="search-content" style="width:100%;margin: 0 auto;">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="810">待收货</el-menu-item>
        <el-menu-item index="820">已收货</el-menu-item>
        <el-menu-item v-for="item in ssoweb" v-if="item.ssocode" :key="item.ssocode" :index="item.ssocode">{{item.deptname}}</el-menu-item>
        <el-menu-item index="storagewarn">镜片库存</el-menu-item>
        <el-menu-item index="storageframe">镜架库存</el-menu-item>
      </el-menu>
      <div class="line"></div>
    </div>
    <el-main>
      <iframe :src="iframeurl" class="framestyle" frameborder="0" scrolling="auto" name="ssowebframe" v-if="showiframe"></iframe>
      <comment :is="currentcomponent" :roletype="'buy'" :mystatus="status" v-if="visible"></comment>
    </el-main>
  </div>
</template>

<script>
  import CstagreementList from './CstagreementList';
  import StorageWarn from '../warehouse/StorageWarn'
  import StorageFrame from '../warehouse/StorageFrame'
  import {ssoBuyWeb,login} from '@/api/ossi';

  export default {
    data() {
      return {
        activeIndex: '810',
        currentcomponent: 'CstagreementList',
        visible: true,
        showiframe:false,
        status: '810',
        iframeurl:'',
        userInfoModel:{},
        ssoweb:[]
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        this.status = key
        this.visible = false
        this.showiframe=false
        if(key=="storagewarn"){
          this.currentcomponent='StorageWarn';
        } else if(key=="storageframe"){
          this.currentcomponent='StorageFrame';
        } else if(key=='810'||key=='820'){
          this.currentcomponent = 'CstagreementList'
        }else {
          this.showiframe = true;
          for (let i in this.ssoweb) {
            if (this.ssoweb[i].ssocode == key) {
              login({idencode:key,tenantid:this.userInfoModel.tenantid}).then(response=> {
                this.iframeurl = window.location.protocol+"//" + response.data.website + "/H5/ssologin.html?token=" + response.data.msg + "&redirecturl=html/dingDan/dingDan_main.html";
              })
              //window.open("http://vue.zyanjing.com/H5/index.html", 'ssowebframe', false)
              break;
            }
          }
          return;
        }

        this.$nextTick(() => {
          this.visible = true
        })
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      if(this.userInfoModel.independentserial=='') {
        ssoBuyWeb().then(response => {
          this.ssoweb = response.data.obj;
        })
      }
    },
    components: {
      CstagreementList,
      StorageWarn,
      StorageFrame
    }

  }


</script>
<style scoped>
  .el-main {
    padding: 0px;
    /*height: calc(100vh - 97px);*/
    width:100%;
    margin:0 auto;
    background-color: white;
    overflow: auto;
  }

  .el-menu-item {
    height: 48px !important;
    line-height: 48px !important;
    font-size: 13px;
    padding: 0 18px !important;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    background: linear-gradient(135deg, #f8f9fc 0%, #eef1f7 100%);
    border-radius: 6px 6px 0 0;
    padding: 0 4px;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    background: transparent;
    color: #409eff;
  }

  .el-menu--horizontal .el-menu-item.is-active {
    border-bottom: 3px solid #409eff !important;
    color: #222 !important;
    font-weight: 600;
    background: transparent !important;
  }

  .el-menu--horizontal .el-menu-item .badge {
    display: inline-block;
    line-height: 16px;
    font-size: 11px;
    min-width: 16px;
    height: 16px;
    background: linear-gradient(135deg, #f56c6c, #e24545);
    color: #fff;
    text-align: center;
    border-radius: 8px;
    position: relative;
    top: -8px;
    margin-left: 3px;
    padding: 0 4px;
    box-shadow: 0 2px 4px rgba(245,108,108,0.3);
  }


  .framestyle {
    width: 100%;
    border: 0px;
    height: calc(100vh - 110px);
    background-size: 100% 100%;
    margin: 0px;
    padding: 0px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Buy.vue